import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export function getEditedNotes(state: ApplicationState) {
    return state.pages.checkoutShipping.editedCartNotes;
}
